import { Injectable } from '@angular/core';

import { map, Observable } from 'rxjs';

import type { DynamicFormConfig } from '@core/ask-hr-dynamic-forms-types';
import { injectTellentAskHttp } from '@core/ask-hr-templates-data';
import type {
  AskHrTicket,
  CreateAskTicket,
  MoveAskTicket,
  UpdateAskHrTicket,
} from '@core/ask-hr-tickets-types';

@Injectable({ providedIn: 'root' })
export class TicketsHttpService {
  private readonly askHttpApi = injectTellentAskHttp();

  public createTicket(template: CreateAskTicket<DynamicFormConfig>): Observable<AskHrTicket> {
    const formData = new FormData();
    formData.append('template_id', `${template.id}`);
    if (template.priority) {
      formData.append('priority', template.priority);
    }
    template.items.forEach(item => {
      if (item.value.value instanceof File) {
        formData.append(`data[${item.hash}]`, item.value.value);
        return;
      } else if (Array.isArray(item.value.value)) {
        item.value.value.forEach((value: string) => {
          formData.append(`data[${item.hash}][]`, `${value}`);
        });
      } else if (
        item.value.value !== null &&
        item.value.value !== undefined &&
        item.value.value !== ''
      ) {
        formData.append(`data[${item.hash}]`, `${item.value.value}`);
        return;
      }
    });
    return this.askHttpApi
      .post('/tickets', null, formData, {
        headers: {
          'x-json-accent': [],
        },
      })
      .pipe(map(res => res.data));
  }

  public updateTicket(id: number, ticket: UpdateAskHrTicket): Observable<AskHrTicket> {
    return this.askHttpApi.patch(`/tickets/${id}`, null, ticket).pipe(map(res => res.data));
  }

  public moveTicket(id: number, ticket: MoveAskTicket): Observable<AskHrTicket> {
    return this.askHttpApi.patch(`/tickets/${id}/move`, null, ticket).pipe(map(res => res.data));
  }

  public cancelTicket(id: AskHrTicket['id']): Observable<AskHrTicket> {
    return this.askHttpApi.delete(`/tickets/${id}/cancel`).pipe(map(res => res.data));
  }

  public fetchOne(id: AskHrTicket['id']): Observable<AskHrTicket> {
    return this.askHttpApi.get(`/tickets/${id}`).pipe(map(res => res.data));
  }
}
